import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { locations } from '../data/site';

export const CallDropdown = () => {
  const [open, setOpen] = useState(false);
  const container = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    const closeOutside = (event) => { if (!container.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('pointerdown', closeOutside);
    return () => document.removeEventListener('pointerdown', closeOutside);
  }, []);
  return (
    <div ref={container} className="call-dropdown" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}
      onBlur={(event) => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false); }}
      onKeyDown={(event) => { if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); } }}>
      <Button ref={trigger} type="button" className="brand-button call-trigger" data-testid="call-now-button"
        aria-expanded={open} aria-controls="call-options" onClick={() => setOpen(true)}>
        <Phone size={15} aria-hidden="true" /><span>Call now</span><ChevronDown size={14} aria-hidden="true" />
      </Button>
      {open && <div id="call-options" className="call-options" data-testid="call-dropdown">
        <div className="call-options-inner">
          {locations.map((location) => <a key={location.id} href={location.tel} data-testid={`nav-call-${location.id}`} onClick={() => setOpen(false)}>
            <span>{location.name}</span><strong>{location.phone}</strong>
          </a>)}
        </div>
      </div>}
    </div>
  );
};